import styled from 'styled-components'

export const ConfirmationMessageContainer = styled.div`
  h1 {
    color: rgb(51, 51, 51);
    font-family: 'Roboto';
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0px;
    line-height: 32px;
    display: flex;

    svg {
      filter: invert(16%) sepia(0%) saturate(0%) hue-rotate(30deg) brightness(100%) contrast(89%);
    }
    span {
      padding-left: 10px;
      display: flex;
      align-self: center;
    }
  }
  p {
    color: #333333;
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0px;
    line-height: 28px;

    span {
      font-weight: bold;
    }
  }
`

export const ConfirmationItemHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding: 16px;
  border-radius: 6px 6px 0px 0px;
  border: 1px solid #cccaca;
  margin-top: 25px;

  > span:nth-child(1) {
    color: rgb(51, 51, 51);
    font-family: 'Roboto';
    font-size: 14px;
    font-weight: normal;
    line-height: 21px;

    > span {
      font-weight: bold;
    }
  }

  > span:nth-child(2) {
    color: rgb(102, 102, 102);
    font-family: 'Roboto';
    font-size: 12px;
    font-style: italic;
    font-weight: normal;
    line-height: 18px;
    width: 296px;
  }
`
